import EventClockIcon from "components/icons/EventClockIcon";
import EventLocationIcon from "components/icons/EventLocationIcon";
import ImagePlaceholder from "components/icons/ImagePlaceholder";
import React from "react";
import { Activity } from "store/campaigns/campaignActivities/campaignActivities.types";
import * as S from "./index.styles";

interface EventItemProps {
  event: Activity;
}

const EventItem: React.FC<EventItemProps> = ({ event }) => {
  const start = new Date(event.start_date_time);
  const end = new Date(event.end_date_time);

  return (
    <S.EventItem key={event.id}>
      <S.EventImageWrapper>
        {event.image_url ? (
          <S.EventImage src={event.image_url} alt={event.activity_title} />
        ) : (
          <ImagePlaceholder />
        )}
      </S.EventImageWrapper>
      <S.EventDetailsWrapper>
        <S.EventName>{event.activity_title}</S.EventName>
        <S.EventInfo>
          <S.Icon>
            <EventClockIcon />
          </S.Icon>
          {start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - {end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}, {start.toLocaleDateString()}
        </S.EventInfo>
        <S.EventInfo>
          <S.Icon>
            <EventLocationIcon />
          </S.Icon>
          {event.place
            ? `${event.place.city}, ${event.place.state}, ${event.place.country}`
            : "No location"}
          {/*event.place ? event.place.city : "No location"*/}
        </S.EventInfo>
      </S.EventDetailsWrapper>
    </S.EventItem>
  );
};

export default EventItem;